document.addEventListener('DOMContentLoaded', () => {
    document.body.addEventListener('click', function (e) {
        const button = e.target.closest('.detailed-button');
        if (button) {
            const item = button.closest('.search-internet-po-adresu__tariffs-wrapper__item');
            const information = item.querySelector('.detailed-information');
            button.classList.toggle('active');
            information.classList.toggle('active');
        }
    });
});
